import React, {useEffect, useMemo, useState} from 'react'
import {Button, Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {UpdateData} from '../SubscriberSlice/SubscriberSlice'
import CreatableSelect from 'react-select/creatable'
import {confirm} from 'react-confirm-box'
import {AuthenticateUser} from '../../../../../Utils/_helpers/RoleAndPermission'
import {
  getalltagsdata,
  CreateData,
  assignetagsContacts,
  addRemoveTagsFromContact,
} from '../../Tags/TagSlice/TagsSlices'
import Select, {MenuListProps, components} from 'react-select'
import TagPopupModal from './TagPopupModal'
import AddFieldModel from './AddFieldModel'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {
  getDefaultRegion,
  getIsDefaultRegion,
} from '../../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {validatePhoneNumberRegion} from '../../../../../Utils/_helpers'
import {useAllTagsMutation} from '../../../../../../services/cellcast.v3'

const optionsWithLabelChange = {
  closeOnOverlayClick: false,
  labels: {
    confirmable: 'Confirm',
    cancellable: 'Cancel',
  },
}

const EditSingleSubscriber = ({show, handleClose, callbackFn}: any) => {
  const groupid: any = useSelector((state: any) => state?.subscriberData?.FieldName?.data?._id)
  const tagslist = useSelector((state: any) => state?.tags?.allTags?.data)
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const defaultRegion = useSelector(getDefaultRegion)
  const dispatch = useDispatch()
  const [error, setError] = useState('')
  const [tag, setTag] = useState<any>([])
  const [listOptions, setListOptions] = useState<any>([])
  const [selectedTag, setSelectedTag] = useState<any>([])
  const [selectedList, setSelectedList] = useState<any>([])

  const [editData, setEditData] = useState<any>({})
  const [openTagPopup, setOpenTagPopup] = useState(false)
  const [openFieldPopup, setOpenFieldPopup] = useState(false)
  const [newFieldsData, setNewFieldsData] = useState<any>({})
  const [fetchAllTagInt, {isLoading: tagIntLoad, data: tagIntData}] = useAllTagsMutation()

  useEffect(() => {
    if(!show){
      return
    }

    if (isDefaultRegion) {
      dispatch(getalltagsdata())
    } else {
      fetchAllTagInt({
        action: 'all_tag',
        data: {},
      })
    }
  }, [isDefaultRegion, show])

  useEffect(() => {
    const filteredTags = tagslist?.filter((val: any) => {
      if (val?.type) {
        return val?.isHidden === false && val?.type !== 'list'
      }
      return val?.isHidden === false
    })
    let listData = filteredTags?.map((val: any) => ({value: val?._id, label: val?.name}))
    setTag(listData)
  }, [tagslist])

  useEffect(() => {
    if (tagIntData?.data) {
      const tagOptions = tagIntData.data
        ?.filter((el) => el.type === 'tag')
        ?.map((el) => ({value: el._id, label: el.name}))
      setTag(tagOptions)
    }
  }, [tagIntData])

  useEffect(() => {
    const filteredTags = tagslist?.filter((val: any) => {
      if (val?.type) {
        return val?.isHidden === false && val?.type === 'list'
      }
      return val?.isHidden === false
    })
    let listData = filteredTags?.map((val: any) => ({value: val?._id, label: val?.name}))
    setListOptions(listData)
  }, [tagslist])

  useEffect(() => {
    if (tagIntData?.data) {
      const tagOptions = tagIntData.data
        ?.filter((el) => el.type === 'list')
        ?.map((el) => ({value: el._id, label: el.name}))
      setListOptions(tagOptions)
    }
  }, [tagIntData])


  const handleCreate = async (e: any) => {
    // if(/^[a-zA-Z0-9_]{2,25}+$/gm.test(e)){
    let confirNew = await confirm(
      'Are you sure you want to create a new tag?',
      optionsWithLabelChange
    )
    setSelectedTag([...selectedTag, {value: e, label: e}])
    confirNew &&
      dispatch(
        CreateData({
          name: e,
        })
      )
    // }
  }
  const handleTagsChange = (e: any) => {
    setSelectedTag(e)
  }

  const handleListChange = (e: any) => {
    setSelectedList(e)
  }

  const handelChange = (e: any) => {
    setEditData({...editData, [e.target.name]: e.target.value})
  }

  const handelNewChange = (e: any) => {
    const tempNewData = newFieldsData?.newData ?? []
    const findDataIndex = tempNewData?.findIndex((data: any) => data?.label == e.target.name)
    tempNewData[findDataIndex] = {...tempNewData[findDataIndex], value: e.target.value}
    setNewFieldsData({
      ...newFieldsData,
      newData: tempNewData,
    })
  }

  const mergedArray: any = show?.data?.group?.[0]?.fields ? [...show?.data?.group?.[0]?.fields] : []

  const finalFieldData = mergedArray?.map((key: any) => {
    if (show?.data?.fields?.find((val: any) => val?.name == key) !== undefined) {
      return show?.data?.fields?.find((val: any) => val?.name == key)
    } else {
      return {name: key, value: ''}
    }
  })
  // const uniqueMergedArray = [...new Set(mergedArray)]
  const handleSubmit = () => {
    let tempTagIds = selectedTag ?? []
    tempTagIds = tempTagIds?.map((tag: any) => tag?.value)

    if (selectedList && Array.isArray(selectedList) && selectedList.length > 0) {
      const listTags = selectedList?.length
        ? selectedList?.map((tag: any) => tag?.value)
        : []
      tempTagIds = [...tempTagIds, ...listTags]
    }

    if (isDefaultRegion) {
      dispatch(addRemoveTagsFromContact({contactIds: show?._id, tagId: tempTagIds}))
    }

    const oldFields = show?.group?.fields ?? []
    const oldLabels = JSON.parse(show?.group?.mergeLabels ?? '[]')
    const newFields = newFieldsData?.newData ?? []
    const newLabels = newFieldsData?.newLabels ?? []
    const getLabels = newFields?.map((field: {label: string}) => field.label)
    const getData = Object.fromEntries(
      newFields.map((field: {label: string; value: string}) => [field.label, field.value])
    )

    let sendRes = {
      data: {
        data: {...editData, ...getData},
        fields: [...oldFields, ...getLabels],
        mergeLabels: JSON.stringify([...oldLabels, ...newLabels]),
      },
      groupId: groupid,
      id: show?._id,
      callbackFn: callbackFn,
      ...(!isDefaultRegion && {region: defaultRegion}),
      ...(!isDefaultRegion && {tag_ids: tempTagIds}),
    }

    dispatch(UpdateData(sendRes))

    setNewFieldsData({})
    handleClose({...show, tags: [], toggle: false})
  }

  useEffect(() => {
    let data: any = {}
    show?.data?.length > 0 && show?.data?.forEach((val: any) => (data[`${val?.name}`] = val?.value))
    for (const key1 in data) {
      let findData = show?.data?.find((key: any) => key?.name == key1)
      if (findData !== undefined) {
        data[`${key1}`] = findData?.value
      }
    }
    data['number'] = show?.number
    let tempTegs = show?.tags ?? []
    const tags = tempTegs?.filter((el: any) => el.type !== 'list')
    const tagOptions = tags?.map((tag: any) => ({
      value: tag?._id,
      label: tag?.name,
    }))
    setSelectedTag(tagOptions)

    const list = tempTegs?.filter((el: any) => el.type === 'list')
    const listOptions = list?.map((tag: any) => ({
      value: tag?._id,
      label: tag?.name,
    }))
    setSelectedList(listOptions)
    setEditData(data)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show?.toggle])

  const checkValidation = () => {
    if (
      editData['number'] !== '' &&
      !validatePhoneNumberRegion(editData['number'], defaultRegion)
    ) {
      setError('Please enter Valid Mobile Number')
    } else {
      setError('')
    }

    if (editData['number'] == '') {
      setError('Please enter Mobile Number')
    }
  }

  const isShowCreateButton = (arr: any, newArr: any) => {
    const oldData = arr?.group?.fields?.length ?? 0
    const newData = newArr?.newData?.length ?? 0
    const sumOfData = oldData + newData
    return sumOfData < 18
  }

  const MenuList = (props: MenuListProps<any>) => {
    return (
      <components.MenuList {...props}>
        {props.children}
        <div
          style={{
            width: '100%',
            display: 'flex',
            gap: '6px',
            cursor: 'pointer',
            alignItems: 'center',
            justifyContent: 'center',
            borderTop: '1px solid #F4F5F7',
            paddingTop: '10px',
          }}
          onClick={() => {
            setOpenTagPopup(true)
          }}
        >
          <i
            style={{
              color: '#7950F2',
              fontWeight: 'bold !important',
            }}
            className='bi bi-plus-lg'
          ></i>
          <p
            style={{
              color: '#7950F2',
              margin: 0,
              fontWeight: 600,
            }}
          >
            Create new
          </p>
        </div>
      </components.MenuList>
    )
  }

  const AddTagPopup = useMemo(
    () => (
      <TagPopupModal
        selectedTag={selectedTag}
        setSelectedTag={setSelectedTag}
        show={openTagPopup}
        handleClose={() => {
          // const newArr = [...selectedTag].filter((key) => key?.value !== '')

          setOpenTagPopup(false)
          // setSelectedTag(newArr)
        }}
      />
    ),
    [openTagPopup]
  )

  const AddFieldPopup = useMemo(
    () => (
      <AddFieldModel
        show={openFieldPopup}
        handleClose={(fieldName: string) => {
          if (!!fieldName) {
            const tempNewData = newFieldsData?.newData ?? []
            const tempNewLabels = newFieldsData?.newLabels ?? []
            setNewFieldsData({
              ...newFieldsData,
              newData: [...tempNewData, {label: fieldName, value: ''}],
              newLabels: [...tempNewLabels, {oldLabel: fieldName, newLabel: fieldName}],
            })
          }
          setOpenFieldPopup(false)
        }}
      />
    ),
    [openFieldPopup]
  )

  return (
    <>
      {AddTagPopup}
      {AddFieldPopup}
      <Modal
        backdrop='static'
        dialogClassName='modal-dialog-centered'
        show={show?.toggle}
        size='lg'
        className='contact-edit-modal'
      >
        <div className='modal-header'>
          <h1>Edit Contact</h1>
          <div
            className='btn btn-icon btn-sm'
            onClick={() => {
              handleClose()
            }}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body px-10'>
          <div className='row mb-4'>
            <label className='p-0 mb-1'>Mobile Number</label>
            <input
              onBlur={checkValidation}
              onChange={handelChange}
              className='form-control form-control-solid'
              name='number'
              value={editData[`number`]}
            />
          </div>
          <span className='text-danger'>{error}</span>
          {show?.data?.length > 0 &&
            show?.data
              ?.filter((val: any) => !val?.name?.toLowerCase().includes('assign'))
              .map((val: any, i: number) => (
              <div className='row mb-4' key={i}>
                <label className='p-0 mb-1'>{val?.name}</label>
                <input
                  name={val?.name}
                  onChange={handelChange}
                  value={editData[`${val?.name}`]}
                  placeholder={val?.name}
                  className='form-control form-control-solid'
                  disabled={val?.name === 'intent'}
                />
              </div>
            ))}
          {newFieldsData?.newData?.length > 0 &&
            newFieldsData?.newData?.map((val: any, i: number) => (
              <div className='row mb-4' key={i}>
                <label className='p-0 mb-1'>{val?.label}</label>
                <input
                  name={val?.label}
                  onChange={handelNewChange}
                  value={val?.value}
                  placeholder={val?.label}
                  className='form-control form-control-solid'
                />
              </div>
            ))}
          {AuthenticateUser('tag-untag-contacts') && (
            <div className='row mb-4'>
              <label className='col-form-label fw-bold fs-6'>List name</label>
              <Select
                value={selectedList}
                isMulti
                className='react-tags-selectbox'
                options={listOptions}
                onChange={handleListChange}
              />
            </div>
          )}
          {AuthenticateUser('tag-untag-contacts') && (
            <div className='row mb-4'>
              <label className='col-form-label fw-bold fs-6'>Tag name</label>
              <Select
                value={selectedTag}
                components={{MenuList}}
                isMulti
                className='react-tags-selectbox'
                options={tag}
                onChange={handleTagsChange}
              />
            </div>
          )}
          <div
            style={{
              width: '100%',
              display: 'flex',
              gap: '6px',
              alignItems: 'center',
              justifyContent: 'center',
              paddingTop: '10px',
              paddingBottom: '10px',
              marginTop: '4px',
              borderRadius: '4px',
              border: isShowCreateButton(show, newFieldsData)
                ? '1px dashed  #7950F2'
                : '1px dashed  #f5f8fa',
              background: isShowCreateButton(show, newFieldsData) ? '#F3F0FB' : '#f5f8fa',
              cursor: isShowCreateButton(show, newFieldsData) ? 'pointer' : 'no-drop',
            }}
            onClick={() => {
              if (isShowCreateButton(show, newFieldsData)) setOpenFieldPopup(true)
            }}
          >
            <i
              style={{
                color: isShowCreateButton(show, newFieldsData) ? '#7950F2' : '#ccc',
                fontWeight: 'bold !important',
              }}
              className='bi bi-plus-lg'
            ></i>
            <p
              style={{
                color: isShowCreateButton(show, newFieldsData) ? '#7950F2' : '#ccc',
                margin: 0,
                fontWeight: 600,
              }}
            >
              Create new field
            </p>
          </div>
        </div>
        <div className='modal-footer'>
          <button
            className='btn btn-danger'
            onClick={() => {
              handleClose({...show, toggle: false})
              setNewFieldsData({})
              setEditData({})
            }}
          >
            Close
          </button>
          <Button disabled={error !== ''} onClick={handleSubmit}>
            Save
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default EditSingleSubscriber
